// skipcq: JS-W1028
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

import TapRatingBar from '../ratings/TapRatingBar';
import ReviewDetailsUnreadCountChip from './ReviewDetailsUnreadCountChip';
import { DETAIL_MUTED, PRIMARY_DETAIL_TEXT } from '../../utils/theme';

function ReviewDetailsItemRow({ item, showUnreadChip = true, showReviewedWhenZero = false }) {
  const typeLabel = item.itemType === 'brewery' ? 'Brewery' : 'Beer';

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 1fr) auto',
        columnGap: 1,
        rowGap: 0.5,
        width: '100%',
        alignItems: 'start',
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography
          variant="body2"
          sx={{
            color: PRIMARY_DETAIL_TEXT,
            fontWeight: 700,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {item.name}
        </Typography>
        <Typography variant="caption" sx={{ color: DETAIL_MUTED }}>
          {typeLabel}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 0.5 }}>
        {showUnreadChip ? (
          <ReviewDetailsUnreadCountChip
            count={item.unseenCount}
            showReviewedWhenZero={showReviewedWhenZero}
          />
        ) : null}
        <TapRatingBar rating={item.averageRating} size="compact" showNumeric />
      </Box>
    </Box>
  );
}

ReviewDetailsItemRow.propTypes = {
  item: PropTypes.shape({
    itemType: PropTypes.oneOf(['beer', 'brewery']).isRequired,
    itemId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    averageRating: PropTypes.number,
    unseenCount: PropTypes.number,
  }).isRequired,
  showUnreadChip: PropTypes.bool,
  showReviewedWhenZero: PropTypes.bool,
};

export default ReviewDetailsItemRow;
